import React, { useEffect, useState } from 'react'
import LavorisService from '../../services/LavorisService';
import { useAlert } from '../../hooks/useAlert';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/combineReducer';
import { useForm } from 'react-hook-form';
import { getErrorMessage } from '../../utils';
import { Modal } from '../../components/others/Modal';
import { Input } from '../../components/core/Input';
import { InputEmail } from '../../components/others/InputEmail';
import { PhoneNumber as PhoneNumberInput } from "../../components/others/PhoneNumber";
import { PrimaryButton } from '../../components/others/ButtonPrimary';

export const UpdatePersonalDataModal = (props: any) => {
    const styles = "text-2xl text-red-500 font-bold";
    const LavorisInstance = LavorisService.getInstance();
    const { showAlert } = useAlert();
    const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]?.id);
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        handleSubmit,
        resetField,
        setValue,
        control,
        watch,
        reset,
        formState: { errors }
    } = useForm({
        mode: 'all'
    });

    useEffect(() => {
        reset({
            phoneNumber: props?.user?.phoneNumber,
            email: props?.user?.email?.trim(),
            id: props?.user?.id,
            userId: props?.user?.userId,
            name: props?.user?.name?.split(',')[1],
            lastname: props?.user?.name?.split(',')[0],
            isCandidate: props?.user?.roles?.includes('COMPANY_CANDIDATE') ? true : false,
        })

    }, [])

    const onSubmit = async (data: any) => {
        setIsLoading(true)
        const name = data?.name?.trim();
        const lastname = data?.lastname?.trim();
        const body = {
            email: data?.email?.trim(),
            phoneNumber: data?.phoneNumber,
            name: name?.trim(),
            lastname: lastname?.trim(),
        }

        try {
            if (data.isCandidate) {
                await LavorisInstance.CompanyServices.updateApplicantData(
                    data.id,
                    data.userId,
                    body,
                )
            }

            if (!data.isCandidate) {
                await LavorisInstance.CompanyServices.updateEmployeeData(
                    data.id,
                    data.userId,
                    body,
                )
            }

            props.setUpdateEmailPhoneData({
                email: data?.email?.trim(),
                phoneNumber: data?.phoneNumber,
                name: `${lastname?.trim()}, ${name?.trim()}`
            })
            props.onClose()
            props.submit(true)
        } catch (err) {
            showAlert(getErrorMessage({ title: 'No se pudo actualizar la información', err }))
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            show={props.show}
            modalTitle={props.modalTitle}
            urlTittle={props.urlTittle}
            onClose={props.onClose}
            titleStyle={styles}
        >
            <div>
                <form className='flex flex-col gap-3' onSubmit={handleSubmit(onSubmit)}>
                    <Input
                        type='text'
                        label='Apellido/s'
                        fieldName='lastname'
                        register={register}
                        error={errors.lastname}
                        required
                    />
                    <Input
                        type='text'
                        label='Nombre/s'
                        fieldName='name'
                        register={register}
                        error={errors.name}
                        required
                    />
                    <InputEmail
                        label="E-mail"
                        nameInput={"email"}
                        register={register}
                        error={errors}
                        required
                    />
                    <PhoneNumberInput
                        control={control}
                        fieldName="phoneNumber"
                        label="Teléfono"
                        error={errors?.phoneNumber}
                        required
                    />

                    <div className="w-full flex justify-end">
                        <PrimaryButton
                            type="submit"
                            text="Actualizar"
                            styles="bg-red-500 font-bold text-white w-1/3"
                            disabled={isLoading}
                        />
                    </div>
                </form>
            </div>


        </Modal>

    )



}
